import { useState, useCallback } from 'react';

const useConfirmation = (onDelete) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemToConfirm, setItemToConfirm] = useState(null);

    const requestConfirmation = useCallback((item) => {
        setItemToConfirm(item);
        setIsModalOpen(true);
    }, []);

    const confirmAction = useCallback(() => {
        onDelete(itemToConfirm); 
        setIsModalOpen(false);
        setItemToConfirm(null); 
    }, [itemToConfirm, onDelete]); 

    const cancelAction = useCallback(() => {
        setIsModalOpen(false);
        setItemToConfirm(null);
    }, []);

    return { 
        modalProps: {
            isOpen: isModalOpen,
            onConfirm: confirmAction,
            onCancel: cancelAction,
        },
        requestConfirmation
    };
};
    
export default useConfirmation;